module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "check"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("直播名称")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.liveName))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("活动名称")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.activityName))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("奖品名称")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.prizeName))])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('a', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回扫码")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v("确认")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29a98108"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/exchange/check.vue
// module id = 505
// module chunks = 0